import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { environment } from '@environments/environment';
import { PublicMetadataInterface, Wallet } from './user.interface';
import { User } from './model/user';
import { FileService } from './file.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private http: HttpClient, private fileService: FileService) {}

  userPhoto = signal('');

  getMetadataById(id: string) {
    return this.http.get<PublicMetadataInterface>(
      `${environment.api.user}/users/metadata/${id}`,
    );
  }

  getUserById(id: string) {
    return this.http.get<User>(`${environment.api.user}/users/${id}`);
  }

  updateMetadata(id: string, metadata: PublicMetadataInterface) {
    return this.http.post<PublicMetadataInterface>(
      `${environment.api.user}/users/metadata/${id}`,
      metadata,
    );
  }

  getUserPhoto(userId: string) {
    return `${environment.api.file}/files/profile/${userId}`;
  }

  async uploadUserPhoto(userId: string, files: File[]) {
    return this.fileService.uploadFiles(`${environment.api.file}/files/profile/${userId}/upload-urls`, files);
  }

  addWallet(userId: string, wallet: {
    cardNumber: string,
    cardHolderName: string,
    expiryDate: string,
    cardType: string,
    isDefault?: boolean,
    externalCardId: string,
  }) {
    return this.http.post(`${environment.api.user}/payments/cards/${userId}`, wallet);
  }

  getWallets(userId: string) {
    return this.http.get<Wallet[]>(`${environment.api.user}/payments/cards/${userId}`);
  };

  selectDefaultCard(userId: string, cardId: string) {
    return this.http.post(`${environment.api.user}/payments/cards/${userId}/${cardId}/default`, {});
  }

  deleteCard(userId: string, cardId: string) {
    return this.http.delete(`${environment.api.user}/payments/cards/${userId}/${cardId}`);
  }

  sendResetPasswordEmail(email: string) {
    return this.http.post(`${environment.api.user}/users/password/otp`, {
      email,
    });
  }

  verifyResetPassword(email: string, code: string) {
    return this.http.post(`${environment.api.user}/users/verify`, {
      email,
      code,
      returnToken: true,
    });
  }

  changePassword(userId: string, token: string, password: string) {
    return this.http.put(`${environment.api.user}/users/password/${userId}`, {
      password,
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    });
  }
}
